export enum DonationPaymentPageType {
  Unknown = 0,
  AuxiliaDefault = 1,
  ClientDefault = 2,
  Custom = 3,
}
